import dayjs from 'dayjs'

/**
 * Extracts standardized audit fields from the user object provided by useAuth.
 * @param {Object} user - The user object from useAuth.
 * @returns {Object} Standardized audit fields.
 */
export const getAuditFields = user => {
  const userId = user?.userId || user?.appUserId || user?.loginId || null
  const auditId = user?.auditId || null
  const timestamp = dayjs().format()

  return {
    appUserId: userId,
    insertUser: userId,
    updateUser: userId,
    insertDate: timestamp,
    updateDate: timestamp,
    auditId: auditId,
    userVO: {
      appUserId: userId
    }
  }
}
